<template>
	<div class="skill-view" v-loading="loading">
		<!-- 标题 -->
		<div class="page-title">
			<i class="el-icon-data-analysis"></i>
			<span>技能概览</span>
		</div>
		<el-tabs v-model="skillId" @tab-click="handleClick">
			<el-tab-pane v-for="(item, i) in skillList" :key="i" :label="item.skillName" :name="item.idString"></el-tab-pane>
		</el-tabs>
		<div class="skill-box">
			<!-- 统计概览 -->
			<div class="stat-cards" v-if="skillId">
				<div class="stat-card card-purple" v-if="overview.total && userId == ''">
					<div class="card-icon">
						<i class="el-icon-user"></i>
					</div>
					<div class="card-content">
						<div class="card-label">总人数</div>
						<div class="card-value">{{ overview.total }}人</div>
					</div>
				</div>

				<div class="stat-card card-green" v-if="overview.evalContent">
					<div class="card-icon">
						<i class="el-icon-help"></i>
					</div>
					<div class="card-content">
						<div class="card-label">参与评价人数</div>
						<div class="card-value">{{ overview.evalContent }}</div>
					</div>
				</div>

				<div class="stat-card card-orange" v-if="overview.starLevel && this.overview.lockLevel == ''">
					<div class="card-icon">
						<i class="el-icon-star-on"></i>
					</div>
					<div class="card-content">
						<div class="card-label">选中等级</div>
						<div class="card-value">{{ overview.starLevel }}</div>
					</div>
				</div>

				<div class="stat-card card-blue" v-if="overview.topPercent && userId == ''">
					<div class="card-icon">
						<i class="el-icon-pie-chart"></i>
					</div>
					<div class="card-content">
						<div class="card-label">选中占比</div>
						<div class="card-value">{{ overview.topPercent }}</div>
					</div>
				</div>

				<div class="stat-card1 card-orange card-lock-level" v-if="overview.lockLevel">
					<div class="card-icon ml25">
						<i class="el-icon-star-on"></i>
					</div>
					<div class="card-content">
						<div class="card-label">当前认定等级</div>
						<el-tooltip :content="overview.lockLevel" placement="top" effect="light">
							<div class="card-value1">{{ overview.lockLevel }}</div>
						</el-tooltip>
					</div>
				</div>
			</div>
			<!-- 筛选条件 -->
			<div class="filter-bar">
				<div class="filter-item">
					<label class="label">区域</label>
					<el-cascader
						v-model="areaId"
						:options="areaList"
						:props="areaProps"
						placeholder="请选择区域"
						:show-all-levels="false"
						clearable
						@change="changeArea"
						collapse-tags></el-cascader>
				</div>
				<div class="filter-item">
					<label>经销商名称</label>
					<el-select
						v-model="agentId"
						placeholder="请选择经销商"
						clearable
						filterable
						remote
						reserve-keyword
						:remote-method="remoteSearchAgent"
						:loading="agentLoading"
						@change="changeAgent"
						style="width: 300px">
						<el-option v-for="item in dealerOptions" :key="item.id" :label="item.name" :value="item.id" />
					</el-select>
				</div>
				<div class="filter-item">
					<label>学员名称</label>
					<el-select
						v-model="userId"
						placeholder="请选择学员"
						clearable
						filterable
						remote
						reserve-keyword
						:remote-method="remoteSearchStudent"
						:loading="studentLoading"
						@change="changeStudent"
						style="width: 240px">
						<el-option v-for="item in studentOptions" :key="item.id" :label="item.name" :value="item.id" />
					</el-select>
				</div>
			</div>
			<!-- 分级列表 -->
			<div class="level-list" v-if="skillId">
				<div class="level-item" v-for="(level1, i) in levelList1">
					<!-- 二级 -->
					<div class="level-header" @click="toggleLevel2(level1)">
						<div class="level-left">
							<i class="el-icon-user-solid level-icon icon-green"></i>
							<span class="level-name">{{ level1.showName + (level1.id > -1 && userId ? "标准" : "") }}</span>
							<span class="level-count" v-if="userId">（{{ level1.passFlag ? "通过" : "未通过" }}）</span>
							<span class="level-count1" v-else @click.stop="handleShowUserList(level1)">（{{ level1.num }}人）</span>
						</div>
						<i :class="['el-icon-arrow-right', { 'is-open': level1.isOpen }]"></i>
					</div>
					<!-- 展开内容 -->
					<el-collapse-transition>
						<div v-show="level1.isOpen" class="level-content" v-loading="level1.loading">
							<div class="level-item" v-if="level1.showList.length == 0">{{ level1.loading ? "加载中..." : "暂无数据" }}</div>
							<div class="level-item" v-for="(level2, ii) in level1.showList">
								<!-- 三级 -->
								<div class="level-header" @click="toggleLevel3(level2)">
									<div class="level-left">
										<i class="el-icon-star-on level-icon icon-orange"></i>
										<span class="level-name">{{ level2.levelName }}</span>

										<span class="level-count" v-if="userId">（{{ level2.passFlag ? "通过" : "未通过" }}）</span>
										<span class="level-count" v-else>（{{ level2.num }}人）</span>
									</div>
									<i :class="['el-icon-arrow-right', { 'is-open': level2.isOpen }]"></i>
								</div>
								<!-- 展开内容 -->
								<el-collapse-transition>
									<div v-show="level2.isOpen" class="level-content" v-loading="level2.loading">
										<div class="level-item" v-if="level2.showList.length == 0">{{ level2.loading ? "加载中..." : "暂无数据" }}</div>
										<div class="level-item" v-for="(level3, ii) in level2.showList">
											<!-- 四级 -->
											<div class="level-header" @click="toggleLevel4(level3)">
												<div class="level-left">
													<i class="el-icon-s-goods level-icon icon-blue"></i>
													<span class="level-name">{{ level3.bundleName }}</span>

													<span class="level-count" v-if="userId">（{{ level3.passFlag ? "通过" : "未通过" }}）</span>
													<span class="level-count" v-else>（{{ level3.num }}人）</span>
												</div>
												<i :class="['el-icon-arrow-right', { 'is-open': level3.isOpen }]"></i>
											</div>
											<!-- 展开内容 -->
											<el-collapse-transition>
												<div v-show="level3.isOpen" class="level-content">
													<div class="course-package">
														<div class="course-list">
															<div
																v-for="(course, courseIndex) in level3.showList"
																:key="`${course.groupId}-${courseIndex}-${course.courseId}`"
																:class="['course-item', getCourseRowClass(level3.showList, courseIndex)]"
																@click="handleCourse(course)">
																<div class="course-left ml5">
																	<span class="course-name">{{ course.courseName }}</span>
																	<span class="course-code">{{ course.courseCode }}</span>
																	<el-tag :class="['course-tag', `tag-${course.eduType}`]">
																		{{ course.eduType == "1" ? "远程" : "集合" }}
																	</el-tag>
																	<!--<el-tag-->
																	<!--	@click="handleCourse(course, true)"-->
																	<!--	v-if="course.passFlag == 0"-->
																	<!--	:class="['course-tag', `tag-3`]">-->
																	<!--	期望开课-->
																	<!--</el-tag>-->
																	<el-tag v-if="course.passFlag == 0" :class="['course-tag', `tag-3`]">未通过</el-tag>
																</div>
																<div class="course-right mr5" v-if="userId == ''">
																	<span :class="['course-count', course.num === 0 ? 'count-zero' : 'count-normal']">
																		{{ course.num }}人
																	</span>
																</div>
															</div>
														</div>
													</div>
												</div>
											</el-collapse-transition>
										</div>
									</div>
								</el-collapse-transition>
							</div>
						</div>
					</el-collapse-transition>
				</div>
			</div>
		</div>
		<!-- 证书列表 -->
		<div class="skill-box cert-box" v-if="certList.length > 0 && userId != ''">
			<div class="stat-card card-purple">
				<div class="card-icon">
					<i class="el-icon-s-management"></i>
				</div>
				<div class="card-content">
					<div class="card-label">其它证书列表</div>
				</div>
			</div>
			<div class="level-list">
				<div class="file-item" v-for="(item, index) in certList" :key="index">
					<div class="file-name">
						<div class="file-icon1">
							<img src="@/assets/images/zhengshu.png" alt="" />
							{{ item.fileName }}
						</div>
						<div class="file-icon">
							<i class="el-icon-download" @click="downloadFile(item)"></i>
						</div>
					</div>
				</div>
			</div>
		</div>
		<SkillViewDialog ref="skillViewDialogRef" />
		<SkillUserListDialog ref="skillUserListDialogRef" />
	</div>
</template>

<script>
import {
	courseSkillAgentList,
	courseSkillUserList,
	otherCertList,
	courseSkillTotalView,
	courseSkillDetailView,
	courseSkillBundleView,
	courseSkillBundleCourseView,
	courseSkillTotalViewPerson,
	courseSkillBundleViewPerson,
	courseSkillBundleCourseViewPerson,
	courseSkillExpectAdd,
	getUserLockLevelName,
	courseSkillGetManageModule,
} from "@/api/skill";
import SkillViewDialog from "./components/SkillViewDialog.vue";
import SkillUserListDialog from "./components/SkillUserListDialog.vue";
export default {
	components: {
		SkillViewDialog,
		SkillUserListDialog,
	},
	data() {
		return {
			loading: false,
			skillId: "",
			skillList: [],
			isOpendSkill: "",
			agentId: "",
			agentLoading: false,
			userId: "",
			studentLoading: false,
			dealerOptions: [],
			studentOptions: [],
			overview: {
				total: 0,
				evalContent: "",
				starLevel: "",
				topPercent: "",
				lockLevel: "",
			},
			levelList1: [],
			showId: "",
			levelId: "",
			bundleId: "",
			areaList: [],
			areaId: "",
			areaProps: {
				multiple: true,
				value: "id",
				label: "name",
				children: "areaList",
				emitPath: false,
				checkStrictly: false,
			},
			certList: [],
		};
	},
	created() {
		// 获取区域数据
		this.getAreaData();
		// 获取技能列表
		this.getSkillList();
	},
	computed: {
		areaIds() {
			return this.areaId && this.areaId.length > 0 ? this.areaId.join(",") : "";
		},
	},
	methods: {
		// 获取区域数据
		getAreaData() {
			let self = this;
			self.$request.post(
				"getListByCodesPerm",
				true,
				{
					codes: "areaType",
				},
				function (r) {
					if (r.code == "0") {
						self.areaList = r.data.areaType;
					} else {
						self.$message.error(r.msg);
					}
				},
			);
		},
		changeArea() {
			this.getSkillList();
		},
		// 获取技能列表
		async getSkillList() {
			this.loading = true;
			await courseSkillGetManageModule({}).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);
				if (res.data.length <= 0) {
					this.loading = false;
					return this.$message.error("暂无技能数据");
				}

				this.skillList = res.data.map((item) => ({
					...item,
					idString: item.id.toString(),
					isOpen: false,
				}));
				if (this.skillId == "" || this.skillId == 0) this.skillId = this.skillList[0].idString;
			});
			this.agentId = "";
			this.levelId = "";
			this.bundleId = "";
			this.showId = "";
			this.userId = "";
			this.certList = [];
			this.overview.starLevel = "";
			this.overview.topPercent = "";
			this.overview.lockLevel = "";
			await courseSkillUserList({ skillId: this.skillId, agentId: this.agentId, areaIds: this.areaIds }).then((res) => {
				this.studentOptions = [];
				this.overview.total = res.data.totalSize;
				this.overview.evalContent = res.data.userSize;
			});
			await courseSkillTotalView({ agentId: this.agentId, skillId: this.skillId, areaIds: this.areaIds }).then((res) => {
				if (res.data.length > 0) {
					this.levelList1 = res.data.map((item) => ({
						...item,
						skillId: this.skillId,
						showList: [],
						isOpen: false,
					}));
				} else {
					this.levelList1 = [];
				}
			});
			// 获取经销商列表
			this.getAgentList();
			this.loading = false;
		},
		// 点击技能
		handleClick(tab, event) {
			this.skillId = tab.name;
			this.overview.starLevel = "";
			this.overview.topPercent = "";
			// 获取经销商列表
			this.getAgentList();
			this.changeAgent("");
		},
		// 获取代理商列表
		getAgentList() {
			courseSkillAgentList({ skillId: this.skillId, areaIds: this.areaIds }).then((res) => {
				this.dealerOptions = res.data;
			});
		},
		// 变更经销商
		changeAgent(val) {
			this.agentId = val;
			this.levelId = "";
			this.bundleId = "";
			this.showId = "";
			this.userId = "";
			this.overview.starLevel = "";
			this.overview.topPercent = "";
			this.overview.lockLevel = "";
			this.certList = [];
			this.getStudentList();
			this.getAgentLevelList();
		},
		remoteSearchAgent(query) {
			// 清空搜索时返回空
			if (!query) {
				this.dealerOptions = [];
				return;
			}
			this.agentLoading = true;
			courseSkillAgentList({ name: query, skillId: this.skillId, areaIds: this.areaIds }).then((res) => {
				this.dealerOptions = res.data;
				this.agentLoading = false;
			});
		},
		// 获取学员列表
		getStudentList() {
			courseSkillUserList({ skillId: this.skillId, agentId: this.agentId, areaIds: this.areaIds }).then((res) => {
				this.studentOptions = this.agentId ? res.data.list : [];
				this.overview.total = res.data.totalSize;
				this.overview.evalContent = res.data.userSize;
			});
		},
		remoteSearchStudent(query) {
			// 清空搜索时返回空
			if (!query || this.agentId == "") {
				this.studentOptions = [];
				return;
			}
			this.studentLoading = true;
			courseSkillUserList({ skillId: this.skillId, agentId: this.agentId, name: query, areaIds: this.areaIds }).then((res) => {
				this.studentOptions = res.data.list;
				this.studentLoading = false;
			});
		},
		// 切换学员
		changeStudent(val) {
			if (val) {
				this.userId = val;
				this.levelId = "";
				this.bundleId = "";
				this.showId = "";
				this.overview.starLevel = "";
				this.overview.topPercent = "";
				this.overview.evalContent = "";
				this.certList = [];
				this.getStudentLevelList();
				getUserLockLevelName({ skillId: this.skillId, userId: this.userId }).then((res) => {
					this.overview.lockLevel = res.data;
				});
				// 获取证书列表
				otherCertList({ userId: this.userId }).then((res) => {
					if (res.code == "0") {
						this.certList = res.data;
					} else {
						this.certList = [];
					}
				});
			} else {
				this.overview.lockLevel = "";
				this.changeAgent(this.agentId);
				this.certList = [];
			}
		},
		// 获取一级菜单
		getAgentLevelList() {
			courseSkillTotalView({ agentId: this.agentId, skillId: this.skillId, areaIds: this.areaIds }).then((res) => {
				if (res.data.length > 0) {
					this.levelList1 = res.data.map((item) => ({
						...item,
						skillId: this.skillId,
						showList: [],
						loading: false,
						isOpen: false,
					}));
				} else {
					this.levelList1 = [];
				}
			});
		},
		getStudentLevelList() {
			courseSkillTotalViewPerson({ userId: this.userId, skillId: this.skillId }).then((res) => {
				if (res.data.length > 0) {
					this.levelList1 = res.data.map((item) => ({
						...item,
						skillId: this.skillId,
						showList: [],
						loading: false,
						isOpen: false,
					}));
				} else {
					this.levelList1 = [];
					this.overview.starLevel = "";
					this.overview.topPercent = "";
				}
			});
		},
		// 点击一星级
		toggleLevel2(item) {
			item.isOpen = !item.isOpen;
			item.loading = item.isOpen ? true : false;
			this.showId = item.id;
			item.isOpen ? this.getShowList() : this.$forceUpdate();
			this.setOverview();
		},
		getShowList() {
			if (this.userId) {
				this.levelList1.forEach((val) => {
					if (this.showId == val.id) {
						val.levelList.forEach((item) => {
							item.skillId = this.skillId;
							item.showId = this.showId;
							item.levelId = item.id;
							item.showList = [];
							item.loading = false;
							item.isOpen = false;
						});
						val.loading = false;
						val.showList = val.levelList;
					}
				});
				return;
			}
			courseSkillDetailView({ agentId: this.agentId, skillId: this.skillId, showId: this.showId, areaIds: this.areaIds }).then((res) => {
				if (res.data.length > 0) {
					let showList = res.data.map((item) => ({
						...item,
						skillId: this.skillId,
						showId: this.showId,
						showList: [],
						loading: false,
						isOpen: false,
					}));
					this.levelList1.forEach((val) => {
						if (this.showId == val.id) {
							val.showList = showList;
							val.loading = false;
						}
					});
				} else {
					this.levelList1.forEach((val) => {
						if (this.showId == val.id) {
							val.showList = [];
							val.loading = false;
						}
					});
				}
			});
		},
		// 点击二级
		toggleLevel3(item) {
			item.isOpen = !item.isOpen;
			item.loading = item.isOpen ? true : false;
			this.skillId = item.skillId;
			this.showId = item.showId;
			this.levelId = item.levelId;
			item.isOpen ? this.getLevelList() : this.$forceUpdate();
			this.setOverview();
		},
		getLevelList() {
			if (this.userId) {
				courseSkillBundleViewPerson({ userId: this.userId, skillId: this.skillId, levelId: this.levelId }).then((res) => {
					if (res.data.length > 0) {
						let showList = res.data.map((item) => ({
							...item,
							skillId: this.skillId,
							showId: this.showId,
							levelId: this.levelId,
							showList: [],
							isOpen: false,
						}));
						this.levelList1.forEach((item) => {
							if (this.showId == item.id) {
								item.showList.forEach((item1) => {
									if (this.levelId == item1.levelId) {
										item1.loading = false;
										item1.showList = showList;
										this.$forceUpdate();
									}
								});
							}
						});
					} else {
						this.levelList1.forEach((item) => {
							if (this.showId == item.id) {
								item.showList.forEach((item1) => {
									if (this.levelId == item1.levelId) {
										item1.loading = false;
										item1.showList = [];
										this.$forceUpdate();
									}
								});
							}
						});
					}
				});
				return;
			}
			courseSkillBundleView({ agentId: this.agentId, skillId: this.skillId, levelId: this.levelId, areaIds: this.areaIds }).then((res) => {
				if (res.data.length > 0) {
					let showList = res.data.map((item) => ({
						...item,
						skillId: this.skillId,
						showId: this.showId,
						levelId: this.levelId,
						showList: [],
						isOpen: false,
					}));
					this.levelList1.forEach((item) => {
						if (this.showId == item.id) {
							item.showList.forEach((item1) => {
								if (this.levelId == item1.levelId) {
									item1.showList = showList;
									item1.loading = false;
									this.$forceUpdate();
								}
							});
						}
					});
				} else {
					this.levelList1.forEach((item) => {
						if (this.showId == item.id) {
							item.showList.forEach((item1) => {
								if (this.levelId == item1.levelId) {
									item1.showList = [];
									item1.loading = false;
									this.$forceUpdate();
								}
							});
						}
					});
				}
			});
		},
		// 点击三级
		toggleLevel4(item) {
			item.isOpen = !item.isOpen;
			this.skillId = item.skillId;
			this.showId = item.showId;
			this.levelId = item.levelId;
			this.bundleId = item.bundleId;
			item.isOpen ? this.getBundleList() : this.$forceUpdate();
			this.setOverview();
		},
		getBundleList() {
			if (this.userId) {
				courseSkillBundleCourseViewPerson({ userId: this.userId, skillId: this.skillId, levelId: this.levelId, bundleId: this.bundleId }).then(
					(res) => {
						if (res.data.length > 0) {
							let showList = res.data.map((item) => ({
								...item,
								skillId: this.skillId,
								showId: this.showId,
								levelId: this.levelId,
								bundleId: this.bundleId,
								showList: [],
								isOpen: false,
							}));
							this.levelList1.forEach((item) => {
								if (this.showId == item.id) {
									item.showList.forEach((item1) => {
										if (this.levelId == item1.levelId) {
											item1.showList.forEach((item2) => {
												if (this.bundleId == item2.bundleId) {
													item2.showList = showList;
													this.$forceUpdate();
												}
											});
										}
									});
								}
							});
						}
					},
				);
				return;
			}
			courseSkillBundleCourseView({
				agentId: this.agentId,
				skillId: this.skillId,
				levelId: this.levelId,
				bundleId: this.bundleId,
				areaIds: this.areaIds,
			}).then((res) => {
				if (res.data.length > 0) {
					let showList = res.data.map((item) => ({
						...item,
						skillId: this.skillId,
						showId: this.showId,
						levelId: this.levelId,
						bundleId: this.bundleId,
						showList: [],
						isOpen: false,
					}));
					this.levelList1.forEach((item) => {
						if (this.showId == item.id) {
							item.showList.forEach((item1) => {
								if (this.levelId == item1.levelId) {
									item1.showList.forEach((item2) => {
										if (this.bundleId == item2.bundleId) {
											item2.showList = showList;
											this.$forceUpdate();
										}
									});
								}
							});
						}
					});
				}
			});
		},
		handleCourse(course, passFlag) {
			this.skillId = course.skillId;
			this.showId = course.showId;
			this.levelId = course.levelId;
			this.bundleId = course.bundleId;
			this.setOverview();
			if (this.userId) {
				if (passFlag) {
					courseSkillExpectAdd({ courseId: course.courseId, skillId: course.skillId }, true).then((res) => {
						if (res.code != "0") return this.$message.error(res.msg);
						this.$message.success("已添加进期望开课清单");
					});
				}
				return;
			}
			let row = {
				agentId: this.agentId, //经销商id
				skillId: course.skillId, //技能id
				courseId: course.courseId,
				areaIds: this.areaIds,
			};
			this.$refs.skillViewDialogRef.init(row);
		},
		// 根据 id 获取对应的 showName
		setOverview() {
			const list = this.levelList1;
			const id = this.showId;
			const item = list.find((item) => item.id == id);
			this.overview.starLevel = item ? item.showName : "";
			this.overview.topPercent = item ? `${Math.round((item.num / this.overview.evalContent) * 100)}%` : "";
		},
		// 显示人员列表
		handleShowUserList(level1) {
			this.$refs.skillUserListDialogRef.init({
				agentId: this.agentId,
				skillId: this.skillId,
				showId: level1.id,
				areaIds: this.areaIds,
			});
		},
		// 计算课程行的斑马纹样式
		getCourseRowClass(showList, index) {
			if (!showList || !showList[index]) return "";

			const currentGroupId = showList[index].groupId;
			let colorIndex = 0;
			let lastGroupId = null;

			// 遍历到当前索引，计算颜色
			for (let i = 0; i <= index; i++) {
				const groupId = showList[i].groupId;
				if (groupId !== lastGroupId) {
					// groupId 变化时切换颜色
					if (i > 0) {
						colorIndex = colorIndex === 0 ? 1 : 0;
					}
					lastGroupId = groupId;
				}
			}
			return colorIndex === 0 ? "course-row-light" : "course-row-dark";
		},
		// 下载证书
		downloadFile(row) {
			const fileLink = row.fileAddr;
			// 判断是否为图片格式，图片在新页面打开
			const imageExts = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp", ".svg"];
			const isImage = imageExts.some((ext) => fileLink.toLowerCase().endsWith(ext));
			if (isImage) {
				window.open(fileLink, "_blank");
				return;
			}
			const linkNode = document.createElement("a");
			linkNode.style.display = "none";
			linkNode.href = fileLink;
			linkNode.download = row.fileName;
			document.body.appendChild(linkNode);
			linkNode.click();
			URL.revokeObjectURL(linkNode.href);
			document.body.removeChild(linkNode);
		},
	},
};
</script>

<style lang="scss" scoped>
.skill-view {
	padding: 24px;
	min-height: 100vh;
	font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

::v-deep .el-tabs__item {
	font-size: 24px;
}

::v-deep .el-tabs__nav-wrap::after {
	display: none;
}

::v-deep .el-tabs__item {
	margin-bottom: 10px;
	font-weight: bold;
}

::v-deep .el-tabs__active-bar {
	height: 4px;
}

/* 标题 */
.page-title {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 27px;
	font-weight: 600;
	color: #303133;
	margin-bottom: 24px;
}

.page-title i {
	color: #4e6ef2;
	font-size: 30px;
}

.nodata-div {
	width: 100%;
	text-align: center;
	img {
		width: 600px;
	}
}

/* 筛选栏 */
.filter-bar {
	display: flex;
	align-items: center;
	gap: 32px;
	margin-bottom: 28px;
}

.no-data {
	width: 830px;
	border: 1px solid #ddd;
	padding: 30px 40px 50px;
	border-radius: 10px;
	margin: 0 auto;
}

.filter-item {
	display: flex;
	align-items: center;
	gap: 10px;
}

.filter-item label {
	font-size: 21px;
	color: #000;
	white-space: nowrap;
	font-weight: 500;
	position: relative;
	padding-left: 18px;
}

.filter-item label::before {
	content: "";
	position: absolute;
	left: 0;
	top: 50%;
	transform: translateY(-50%);
	width: 4px;
	height: 20px;
	background: #409eff;
	border-radius: 2px;
}

/* 统计概览标题 */
.section-title {
	font-size: 22.5px;
	font-weight: 600;
	color: #303133;
	margin-bottom: 16px;
}

/* 统计卡片 */
.stat-cards {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 16px;
	margin-bottom: 24px;
}

.card-lock-level {
	grid-column: 1 / -1;
	width: 100%;
}

.stat-card1 {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 16px;
	padding: 20px 0px;
	border-radius: 12px;
	background: #fff;
}

.stat-card {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 16px;
	padding: 20px 24px;
	border-radius: 12px;
	background: #fff;
}

.card-purple {
	background: linear-gradient(135deg, #ede9ff 0%, #f3f0ff 100%);
}
.card-green {
	background: linear-gradient(135deg, #e6f9f0 0%, #f0fbf5 100%);
}
.card-orange {
	background: linear-gradient(135deg, #fff4e6 0%, #fff8f0 100%);
}
.card-blue {
	background: linear-gradient(135deg, #e8f4ff 0%, #f0f8ff 100%);
}

.card-icon {
	width: 48px;
	height: 48px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 33px;
	flex-shrink: 0;
}

.card-purple .card-icon {
	background: #7c5cfc;
	color: #fff;
}
.card-green .card-icon {
	background: #2ecb8a;
	color: #fff;
}
.card-orange .card-icon {
	background: #ffaa00;
	color: #fff;
}
.card-blue .card-icon {
	background: #4e9eff;
	color: #fff;
}

.card-label {
	font-size: 19.5px;
	color: #909399;
	margin-bottom: 4px;
}

.card-value {
	font-size: 30px;
	font-weight: 700;
	color: #303133;
}

.card-value1 {
	font-size: 30px;
	font-weight: 700;
	color: #303133;
	max-width: 1100px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

/* 分级列表 */
.level-list {
	background: #fff;
	border-radius: 12px;
	overflow: hidden;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.level-item {
	border-bottom: 1px solid #f0f2f5;
}

.level-item:last-child {
	border-bottom: none;
}

.level-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px 20px;
	cursor: pointer;
	transition: background 0.2s;
	/* border-left: 1px dotted #ebeef5; */
}

.level-header:hover {
	background: #fafbff;
}

.level-left {
	display: flex;
	align-items: center;
	gap: 8px;
}

.level-icon {
	font-size: 27px;
}

.icon-purple {
	color: #7c5cfc;
}
.icon-blue {
	color: #4e9eff;
}
.icon-orange {
	color: #ffaa00;
}
.icon-green {
	color: #2ecb8a;
}

.level-name {
	font-size: 22.5px;
	font-weight: 500;
	color: #303133;
}

.level-count {
	font-size: 21px;
	color: #909399;
}

.level-count1 {
	font-size: 21px;
	color: #909399;
}

.level-count1[style*="cursor"] {
	text-decoration: underline;
	cursor: pointer;
}

.level-count1:hover {
	color: #409eff;
}

.el-icon-arrow-right,
.el-icon-arrow-down {
	color: #c0c4cc;
	transition: transform 0.3s;
}

.el-icon-arrow-right.is-open {
	transform: rotate(90deg);
}

/* 展开内容 */
.level-content {
	padding: 0 20px 20px;
	border-top: 1px solid #f0f2f5;
	/* border-left: 1px dotted #ebeef5; */
}

/* 课程包 */
.course-package {
	background: #f8f9fd;
	border-radius: 10px;
	overflow: hidden;
	margin-top: 10px;
}

.package-header {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 14px 18px;
	cursor: pointer;
	border-bottom: 1px solid #eef0f6;
}

.package-icon {
	color: #7c5cfc;
	font-size: 24px;
}

.package-name {
	font-size: 21px;
	font-weight: 500;
	color: #303133;
}

.package-count {
	font-size: 19.5px;
	color: #909399;
}

/* 课程列表 */
.course-list {
	//padding: 0 18px;
}

.course-item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 6px 0;
	border-bottom: 1px solid #eef0f6;
	cursor: pointer;
	transition: background 0.2s;
}

.course-item:last-child {
	border-bottom: none;
}

/* 斑马纹样式 - 浅色行 */
.course-item.course-row-light {
	background-color: #e8f4ff;
	//background: linear-gradient(135deg, #e8f4ff 0%, #f0f8ff 100%);
}

/* 斑马纹样式 - 深色行 */
.course-item.course-row-dark {
	background-color: rgba(255, 255, 255, 0.58);
}

.course-left {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
}

.course-name {
	font-size: 19.5px;
	color: #303133;
}

.course-code {
	font-size: 18px;
	color: #909399;
}

.course-tag {
	border-radius: 4px;
	font-size: 16.5px;
}

/* 远程 tag - 蓝色 */
::v-deep .tag-1.el-tag {
	background: #ecf5ff;
	border-color: #b3d8ff;
	color: #409eff;
}

/* 集合 tag - 紫色 */
::v-deep .tag-2.el-tag {
	background: #f0ebff;
	border-color: #c8b0ff;
	color: #7c5cfc;
}

/* 集合 tag - 红色 */
::v-deep .tag-3.el-tag {
	background: #f3cde3;
	border-color: #f87190;
	color: #f56c6c;
}

.course-count {
	font-size: 21px;
	font-weight: 600;
}

.count-normal {
	color: #f56c6c;
}

.count-zero {
	color: #c0c4cc;
}

.skill-box {
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	padding: 20px;
}

.cert-box {
	margin-top: 20px;
	.file-item {
		padding: 15px;
		border-bottom: 1px solid #f0f2f5;
		&:hover {
			background: #fafbff;
		}
	}
	.file-name {
		display: flex;
		align-items: center;
		gap: 10px;
		font-size: 13px;
	}
	.file-icon1 {
		display: flex;
		align-items: center;
		gap: 10px;
		font-size: 20px;
		img {
			width: 24px;
		}
	}
	.file-icon {
		cursor: pointer;
		i{
			font-size: 20px;
		}
	}
	.stat-card {
		margin-bottom: 24px;
	}
	.card-label{
		color: #000;
	}
}
</style>
